import { inject, Injectable } from '@angular/core';
import { NotificationService } from '@core/services/notification-service/notification.service';

/** Erreur HTTP normalisée — même forme qu'elle vienne d'axios (SDK) ou d'HttpClient. */
export interface HttpErrorInfo {
  /** Absent (ou 0) quand la requête n'a obtenu aucune réponse : réseau, CORS, timeout. */
  status?: number;
  /** `detail` renvoyé par le backend (problem+json), non traduit. */
  detail?: string;
  cancelled?: boolean;
}

/**
 * Point unique qui transforme une erreur HTTP en toast, appelé par l'intercepteur axios du
 * SDK et par l'intercepteur HttpClient. Le toast est un repli (`errorFallback`) : il s'efface
 * si l'appelant affiche sa propre erreur, et ne s'affiche que pour une erreur que personne
 * ne gère.
 */
@Injectable({ providedIn: 'root' })
export class HttpErrorNotifierService {
  private readonly notificationService = inject(NotificationService);

  notify(error: HttpErrorInfo): void {
    // 401 : redirection vers le login, gérée par l'appelant de ce service. Annulée : volontaire.
    if (error.cancelled || error.status === 401) {
      return;
    }
    this.notificationService.errorFallback(this.messageKey(error.status), {
      description: error.detail,
      // Une rafale d'échecs (panne réseau, service tombé) produit un seul toast.
      id: 'global-http-error',
    });
  }

  private messageKey(status?: number): string {
    if (!status) {
      return 'SHARED.ERRORS.NETWORK';
    }
    return status >= 500 ? 'SHARED.ERRORS.SERVER' : 'SHARED.ERRORS.GENERIC';
  }
}
